import React, { type PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { isQrCampaignsEnabled } from './featureFlag';

type Props = PropsWithChildren<{
  user: Parameters<typeof isQrCampaignsEnabled>[0];
  isLoading: boolean;
}>;

export default function QrCampaignsRouteGate({ user, isLoading, children }: Props) {
  if (isLoading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return isQrCampaignsEnabled(user) ? <>{children}</> : <Navigate to="/commercial-ops" replace />;
}
